import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-flags',
    templateUrl: './flags.component.html',
    styleUrls: ['./flags.component.scss']
})
export class FlagsComponent {

    constructor(
        private modalCtrl: ModalController
    ) { }

    fecharClicked() {
        this.modalCtrl.dismiss();
    }

}
